import { render, staticRenderFns } from "./AppointmentTemplate.vue?vue&type=template&id=5af4b7e0"
import script from "./AppointmentTemplate.vue?vue&type=script&lang=ts"
export * from "./AppointmentTemplate.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentTemplate.vue?vue&type=style&index=0&id=5af4b7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports